import * as React from 'react';

import { type InputState, stateClasses } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export const textareaBaseStyles =
  'border-input dark:bg-input/30 focus-visible:border-ring focus-visible:ring-gray-400/50 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 rounded-xl border bg-custom-background-input-30 px-3.5 py-1.5 text-sm transition-[color,border-color,box-shadow] duration-200 ease-out motion-reduce:transition-none focus-visible:ring-[3px] placeholder:text-muted-foreground flex field-sizing-content h-[60px] min-h-[60px] w-full outline-none disabled:cursor-not-allowed disabled:opacity-50 read-only:bg-muted read-only:cursor-default disabled:read-only:opacity-100 disabled:read-only:border-border';

export interface TextareaProps extends React.ComponentProps<'textarea'> {
  /** Visual state of the textarea (default, success, destructive) */
  state?: InputState;
  /** Whether to show an outline/border variant */
  hasOutline?: boolean;
  /** Text direction for RTL support. Use 'auto' for automatic detection based on content. */
  dir?: 'ltr' | 'rtl' | 'auto';
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, state = 'default', hasOutline, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        data-state={state}
        aria-invalid={state === 'destructive' || undefined}
        className={cn(
          textareaBaseStyles,
          stateClasses[state],
          hasOutline &&
            'border-border ring-1 ring-border focus-visible:ring-2 focus-visible:ring-ring',
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
